<template>
  <div
    v-if="unavailable || isUserUnavailable"
    class="v3-dashboard-banners-item"
    role="region"
    :aria-labelledby="bannerTitleId"
  >
    <div class="text-center">
      <div>
        <h2 :id="bannerTitleId" class="v3-dashboard-banners-item-title">
          <i class="ri-briefcase-line" aria-hidden="true"></i>
          Out of Office
          <button
            v-if="unavailable"
            type="button"
            class="v3-dashboard-banners-close-btn cursor-pointer ms-1"
            aria-label="End Out of Office"
            @click="closeUnavailableAlert()"
          >
            <i class="ri-close-line" aria-hidden="true"></i>
          </button>
        </h2>
      </div>
      <Transition name="banner">
        <div v-if="active" class="mt-2">
          <div>
            Your Out of Office is currently on and will end on
            {{
              helpers.transformDate(
                unavailable.to_date,
                "ddd, MM/DD/YYYY h:mm A"
              )
            }}
          </div>
          <div
            v-if="unavailable.comment"
            class="v3-dashboard-banners-item-reason"
          >
            Note: {{ unavailable.comment }}
          </div>
        </div>
      </Transition>
    </div>
  </div>
</template>

<script>
import { computed, inject } from "vue"
import { useStore } from "vuex"
import helpers from "@/helpers/index.js"

export default {
  name: "OutOfOfficeBanner",
  props: {
    unavailable: {
      type: Object,
      default: null
    },
    isUserUnavailable: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const store = useStore()
    const actionDialog = inject("actionDialog")

    const bannerTitleId = computed(
      () => `ooo-banner-title-${props.unavailable?.id ?? "active"}`
    )

    const closeUnavailableAlert = () => {
      if (!props.unavailable) {
        return
      }

      actionDialog.open(endUnavailable, {
        args: props.unavailable,
        props: {
          danger: true,
          title: "End Out of Office",
          question: "Are you sure you want to end this Out of Office?"
        }
      })
    }

    const endUnavailable = (unavailable) => {
      if (unavailable && unavailable.id && unavailable.status) {
        store.dispatch("outOfOfficePasses/updateOutOfOfficeStatus", {
          id: unavailable.id,
          params: { dashboard: true }
        })
      }
    }

    return {
      helpers,
      bannerTitleId,
      closeUnavailableAlert
    }
  }
}
</script>
